module.exports = __webpack_public_path__ + "img/bulb.d22e10b8.svg";